module.exports = __webpack_public_path__ + "img/grupo.5d25d846.svg";